import Constants from '../DataManagement/Constants';

const initialState = {
  canDrag: true,
  canSnap: true,
  doneButtonEnabled: false,
  lightBulbsDisabled: false,
};

/**
 * Controls what actions the user can currently do at this time.
 * @param {*} state
 * @param {*} action
 */
const interactionReducer = (state = initialState, action) => {
  if (action.gameId !== Constants.GAME_ID) {
    return state;
  }
  switch (action.type) {
    case Constants.REDUX_ACTIONS.BEGIN_LEVEL:
      return {
        ...initialState,
        canDrag: !action.payload.isOnboarding,
      };

    case Constants.REDUX_ACTIONS.UPDATE_CANDRAG:
      return {
        ...state,
        canDrag: action.payload,
      };

    case Constants.REDUX_ACTIONS.UPDATE_CANSNAP:
      return {
        ...state,
        canSnap: action.payload,
      };

    case Constants.REDUX_ACTIONS.UPDATE_DONEBUTTONENABLED:
      return {
        ...state,
        doneButtonEnabled: action.payload,
      };

    case Constants.REDUX_ACTIONS.UPDATE_LIGHTBULBSDISABLED:
      return {
        ...state,
        lightBulbsDisabled: action.payload,
      };

    default:
      return state;
  }
};

export default interactionReducer;
